import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from '@awaze/design-system.components.link';
import { Logo, getLogoConfig } from '@awaze/design-system.components.logo';
import { useDisclosure } from '@awaze/design-system.utils.react';
import { Burger } from './burger';
import { DesktopMenu } from './desktop-menu';
import { MobileMenu } from './mobile-menu';
import { CentralNavigationLink, ResponsiveHeaderContainer, ResponsiveHeaderStyled, } from './responsive-header.styles';
import { PhoneIconComponent } from './phone-icon/phone-icon';
/**
 * TODO: Description to be provided by component owner.
 */
// Helper for filtering menu items by displayFor
export const filterMenu = (items = [], isLoggedIn) => {
    return (items ?? []).filter((item) => {
        if (!item.displayFor || item.displayFor === 'Both')
            return true;
        if (item.displayFor === 'Logged in')
            return isLoggedIn;
        if (item.displayFor === 'Logged out')
            return !isLoggedIn;
        return false;
    });
};
export const ResponsiveHeader = ({ brand, menuItems, centralNavigationLink, phoneNumber, labels = {
    closeButtonText: 'Close menu',
    menuButtonText: 'Open menu',
}, shadow, locale, logoLink, showMegaMenu, user, }) => {
    const { isOpen, open, close } = useDisclosure();
    const { isLogoFullHeight } = getLogoConfig(brand);
    const isLoggedIn = !!user?.email;
    // Filter menus depending on the user's login status
    const filteredDesktopMenu = filterMenu(menuItems.desktopMenu, isLoggedIn);
    const filteredMobileMenu = filterMenu(menuItems.mobileMenu, isLoggedIn);
    return (_jsxs(_Fragment, { children: [_jsx(ResponsiveHeaderStyled, { className: "nav-header", isLogoFullHeight: isLogoFullHeight, shadow: shadow, children: _jsxs(ResponsiveHeaderContainer, { children: [_jsx(Link, { href: logoLink ?? '/', colourScheme: "none", underline: false, children: _jsx(Logo, { brand: brand, variant: "header", "aria-label": "logo-image", locale: locale }) }), centralNavigationLink && (_jsx(CentralNavigationLink, { href: centralNavigationLink.href, onlyMobile: centralNavigationLink?.onlyMobile, children: centralNavigationLink.label })), phoneNumber?.displayPhoneIcon && (_jsx(PhoneIconComponent, { phoneNumber: phoneNumber.href, title: phoneNumber.label })), _jsx(Burger, { isOpen: isOpen, onClick: open, menuButtonText: labels.closeButtonText, showMegaMenu: showMegaMenu }), _jsx(DesktopMenu, { user: user, brand: brand, menuItems: filteredDesktopMenu, showMegaMenu: showMegaMenu })] }) }), _jsx(MobileMenu, { isOpen: isOpen, close: close, closeButtonText: labels.closeButtonText, user: user, menuItems: filteredMobileMenu, showMegaMenu: showMegaMenu })] }));
};
//# sourceMappingURL=responsive-header.js.map